<template>
  <Exams />
</template>

<script>
import Exams from '@/components/admin/recommendations/Exams.vue'

export default {
  name: 'AdministrationExams',
  components: { Exams }
}
</script>

<style scoped>

</style>
